export enum DefiningAttributeName {
  COLOR = 'color',
  LENGTH = 'length',
  SIZE = 'size',
  WEIGHT = 'weight',
  WIDTH = 'width',
}
